import { render, staticRenderFns } from "./StatusTasks.vue?vue&type=template&id=3295fb62&scoped=true&lang=pug"
import script from "./StatusTasks.vue?vue&type=script&lang=js"
export * from "./StatusTasks.vue?vue&type=script&lang=js"
import style0 from "./StatusTasks.vue?vue&type=style&index=0&id=3295fb62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3295fb62",
  null
  
)

export default component.exports